import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 19.91 20",
  "content": "<symbol viewBox=\"0 0 19.91 20\" id=\"edit\"><title>edit</title><path d=\"M18.71,7.56v10a1.36,1.36,0,0,1-1.36,1.25H2.52a1.24,1.24,0,0,1-1.24-1.24V2.68A1.35,1.35,0,0,1,2.53,1.33h10V.09h-10A2.59,2.59,0,0,0,0,2.68V17.53A2.47,2.47,0,0,0,2.52,20H17.35A2.6,2.6,0,0,0,20,17.51v-10Z\" transform=\"translate(-0.04 0)\" /><path d=\"M5.67,10.63,3,16c-.22.61.26,1.16.87.87l5.41-2.68a1.21,1.21,0,0,0,.64-.32L19.53,4.3a1.24,1.24,0,0,0,0-1.75L17.35.36a1.24,1.24,0,0,0-1.75,0L6,10A1.21,1.21,0,0,0,5.67,10.63ZM16,1.67a.62.62,0,0,1,.87,0L18.22,3a.62.62,0,0,1,0,.87L16.91,5.17,14.76,3Zm-2.2,2.2L16,6,9,13,6.86,10.86ZM8,13.71l-3.34,2a.32.32,0,0,1-.44-.44l2-3.34Z\" transform=\"translate(-0.04 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/edit.svg
// module id = KJUk
// module chunks = 264